import { DropdownItemProps } from "semantic-ui-react";
import { ValidationProcess } from "../store/validationProcess";

export enum EStatusOption {
    All = 0,
    SuccessfullyFinished = 1,
    PartiallyFailed = 2,
    Running = 3,
    ManuallyStopped = 4,
    CompletelyFailed = 5,
}

export interface ILogsFilters {
    calculationDate?: string;
    user?: string;
    started?: string;
    action: number;
    validationProcess: ValidationProcess;
    calculationStatus: EStatusOption;
}

export const logsFiltersInit: ILogsFilters = {
    calculationDate: "",
    user: "",
    started: "",
    action: -1,
    validationProcess: ValidationProcess.Unknown,
    calculationStatus: EStatusOption.All,
};

export const calculationTypeOptions: DropdownItemProps[] = [
    /*{ key: 0, text: "Perform security assessment", value: 0 },*/
    { key: 1, text: "Estimate security reserve", value: 1 },
    { key: 2, text: "F427 conversion", value: 2 },
];

/*
export const intradayFilterOptions: DropdownItemProps[] = [
    { key: 0, text: "DA & ID", value: -1 },
    { key: 1, text: "DA", value: 0 },
    { key: 2, text: "ID", value: 1 },
];
*/

export const validationProcessFilterOptions: DropdownItemProps[] = [
    { key: ValidationProcess.Unknown, text: "All", value: ValidationProcess.Unknown },
    { key: ValidationProcess.DayAhead, text: "DA", value: ValidationProcess.DayAhead },
    { key: ValidationProcess.IntraDay, text: "ID", value: ValidationProcess.IntraDay },
    { key: ValidationProcess.Ltcc, text: "LT", value: ValidationProcess.Ltcc },
];

export interface ITraceFilters {
    added: string;
    calculationDate: string;
    username: string;
    actionType: number;
}

export const traceFiltersInit: ITraceFilters = {
    added: "",
    calculationDate: "",
    username: "",
    actionType: 0,
};

export const pageSizeOptions = [
    { key: 0, value: 10, text: "10" },
    { key: 1, value: 20, text: "20" },
    { key: 2, value: 50, text: "50" },
];

export const statusOptions = [
    { key: 0, value: EStatusOption.All, text: "All" },
    { key: 1, value: EStatusOption.SuccessfullyFinished, text: "Successfully finished" },
    { key: 2, value: EStatusOption.PartiallyFailed, text: "Partially failed" },
    { key: 3, value: EStatusOption.Running, text: "Running" },
    { key: 4, value: EStatusOption.ManuallyStopped, text: "Manually stopped" },
    { key: 5, value: EStatusOption.CompletelyFailed, text: "Completely failed" },
];
